import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans, useTranslation } from 'react-i18next'
import { Formik, Form } from 'formik'

import { Box, Button } from '@material-ui/core'
import { validatePostalCode, validateNumber, validateStair, validatePortal, validateFloor, validateDoor } from 'utils/validators'
import { getNormalizedCities, getNormalizedStreets } from 'services/address/api'
import { getCalculatorInfo } from '@zatopek/core/src/services/supplyPoint/api'
import { getTechnicalInfo } from '@zatopek/core/src/services/addressFinder/api'
import { getLeadId, getLead } from 'services/lead/selectors'
import { fetchLead } from 'services/lead/actions'
import { capitalizeFirstLetter } from '@zatopek/core/src/utils/capitalizeFirstLetter'
import { isEmptyObject } from '@zatopek/core/src/utils/isEmptyObject'

import NewSupplyView from 'ui/modals/newSupply'
import AddressForm from 'ui/forms/address'
import Typography from 'ui/components/typography'
import Link from 'ui/components/link'

import AddressErrorsAlert from 'ui/components/addressErrorsAlert'
import { getTariffData, isNotEmpty } from 'utils/commons'

import { ADDRESS, GA_EVENT_NAMES, STEPS, BOTH } from 'utils/constants'
import { BOTH_ENUM, ELECTRICITY, GAS } from '@zatopek/core/src/utils/constants'
import { mapNewSupplyAddressLine } from 'services/customer/business'
import { cpProvinces } from '@zatopek/core/src/utils/enums'
import { setSupplyAddress, setDualAddressAlert, setSupplyPoint, setSupplyAddressPayload } from 'services/customer/actions'
import { getIsMultiPoint, getSupplyAddress, getSelectedTenure, getAddresDualAlert, getCompany } from 'services/customer/selectors'
import { showModal } from 'services/modal/actions'
import { MODAL_TYPES } from 'services/modal/constants'
import { put } from 'services/client'
import { getOrders } from 'services/order/selectors'
import { getSelectedRate } from 'services/products/selectors'
import { getSelectedChannel } from 'services/operator/selectors'
import { getActiveStep } from 'services/stepper/selectors'
import { getSelectedCompany } from 'services/customer/selectors'
import { sendGAEvent } from 'services/analytics/actions'
import mapEmergyaAddress from '@zatopek/core/src/utils/mapEmergyaAddress'
const NewSupplyAddress = ({
  handleClose,
  data: {
    completeSupplyPoint,
    service,
    supplyModeService,
    addressCups,
    shouldGetCalculations,
    step,
    energyStep,
    supplyTechnicalInfo,
    userDocumentNumber,
    documentType,
    checkAddressObject,
    showContractTypeError,
    setIsContractCapacityVisible,
    isOnlineChannel: isOnlineChannelProp,
    isOnlyToppings: isOnlyToppingsProp,
    verticalsDetail,
    onNewSupplyChange,
    wrongCupsValidation,
  },
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const leadId = useSelector(getLeadId)
  const lead = useSelector(getLead)
  const supplyAddress = useSelector(getSupplyAddress)
  const isMultiPoint = useSelector(getIsMultiPoint)
  const selectedTenure = useSelector(getSelectedTenure)
  const [municipalityCode, setMunicipalityCode] = useState()
  const [provinceCode, setProvinceCode] = useState()
  const [cities, setCities] = useState([])
  const [streetTypes, setStreetTypes] = useState([])
  const [allStreets, setAllStreets] = useState([])
  const [streetSuggestions, setStreetSuggestions] = useState([])
  const [googleAddress, setGoogleAddress] = useState(false)
  const [selected, setSelected] = useState('')
  
  const [notFoundAddress, setNotFoundAddress] = useState(false)
  const [cityInputValue, setCityInputValue] = useState('')
  const [streetInputValue, setStreetInputValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [waitingForAddressId, setWaitingForAddressId] = useState(false)
  const [pendingFormData, setPendingFormData] = useState(null)
  const [shouldSendLead, setShouldSendLead] = useState(false)
  const [isSendingLead, setIsSendingLead] = useState(false)
  const orders = useSelector(getOrders)
  const checkDualAddresAlert = useSelector(getAddresDualAlert)
  const selectedProductArray = useSelector(getSelectedRate)
  const selectedProduct = selectedProductArray
  const supplyPoints = useSelector((state) => {
    return state.customer.supplyPoints
  })
  const channel = useSelector(getSelectedChannel)
  const company = useSelector(getSelectedCompany)
  const companySelected = useSelector(getCompany)
  const companyCode = company?.code || companySelected?.code
  const [btnState, setBtnState] = useState(true)
  const isDual = !!selectedProduct[0]?.subProducts || selectedProduct?.length === 2
  const activeStep = useSelector(getActiveStep)
  const { isGasSelected, isElectricitySelected } = checkAddressObject || {}
  const orderId = orders && orders.length && orders[0].id
  let checkDualDirection = false

  // Normalizar service a MINÚSCULAS para comparación (las constantes están en minúsculas)
  const normalizedService = service?.toLowerCase()
  const addressAvailableEnergies = normalizedService === BOTH_ENUM || normalizedService === GAS || normalizedService === ELECTRICITY
  const showAddress = addressAvailableEnergies || isMultiPoint
  const isGasInDual = supplyModeService === BOTH_ENUM && normalizedService === GAS
  
  // Variables locales para usar en la línea 696
  const isOnlineChannel = isOnlineChannelProp
  const isOnlyToppings = isOnlyToppingsProp

  const addressInitialValues = {
    postalCode: '',
    city: '',
    province: '',
    streetType: '',
    street: '',
    number: '',
    portal: '',
    stair: '',
    floor: '',
    door: '',
    extraData: '',
  }

  const initialValues = { ...addressInitialValues }

  const handleNotFoundAddress = (e, setFieldValue) => {
    e.preventDefault()
    setNotFoundAddress(!notFoundAddress)
    if (setFieldValue) {
      setFieldValue('street', '')
    }
  }

  const checkIsContratable = useCallback((contratable) => {
    const isContratable = contratable !== 'N'

    if (!isContratable) {
      dispatch(
        showModal({
          modalType: MODAL_TYPES.error,
          modalData: {
            translationLabel: 'contratableField',
          },
        })
      )
    }
    return isContratable
  }, [dispatch])
  const showNoCPModal = (tenureCheck) => {
    dispatch(
      showModal({
        modalType: MODAL_TYPES.warningModal,
        modalData: {
          titleKey: 'addressValidation.modal.title',
          textKey: tenureCheck ? `addressValidation.modal.diferentCPTenure` : `addressValidation.modal.diferentCP`,
        },
      })
    )
  }

  const normalizaAddress = (address) => {
    return address?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  const checkDualAddress = (supplyPoint, stepNumber, checkAddress, tenureCheck) => {
    if (isMultiPoint) return true
    if (activeStep === 4) return true
    if (
      checkAddress &&
      supplyPoint.length === 2 &&
      !Object.values(supplyPoint[0]).every((value) => value === undefined) &&
      !Object.values(supplyPoint[1]).every((value) => value === undefined)
    ) {
      if (supplyPoint[0].postalCode !== supplyPoint[1].postalCode) {
        put(`orders/${orderId}/dual_address_message`, { dualAddressMessage: 'error' })
        showNoCPModal(tenureCheck)
        return false
      }
      const address1 = supplyPoint[0]
      const address2 = supplyPoint[1]

      if (
        (address1?.streetName === address2?.streetName ||
          address1?.streetName?.includes(address2?.streetName) ||
          normalizaAddress(address1?.streetName)
            ?.replace(/[^a-zA-Z0-9]/g, '')
            .toUpperCase() ===
            normalizaAddress(address2?.streetName)
              ?.replace(/[^a-zA-Z0-9]/g, '')
              .toUpperCase()) &&
        (String(parseInt(address1?.number, 10)) === String(parseInt(address2?.number, 10)) ||
          String(parseInt(address1?.addressNumber, 10)) === String(parseInt(address2?.number, 10)) ||
          String(address1?.number)?.replace(/^[0\s]+/, '') === String(address2?.number)?.replace(/^[0\s]+/, '') ||
          String(address1?.addressNumber)?.replace(/^[0\s]+/, '') === String(address2?.number)?.replace(/^[0\s]+/, '')) &&
        (address1?.floor?.replace(/^[0\s]+/, '') === address2?.floor?.replace(/^[0\s]+/, '') ||
          address1?.addressFloor?.replace(/^[0\s]+/, '') === address2?.floor?.replace(/^[0\s]+/, '') ||
          (!address1.floor && !address2.floor && !address1.addressFloor)) &&
        (address1?.door?.replace(/^[0\s]+/, '') === address2?.door?.replace(/^[0\s]+/, '') ||
          address1?.addressDoor?.replace(/^[0\s]+/, '') === address2?.door?.replace(/^[0\s]+/, '') ||
          (!address1?.door && !address2?.door && !address1?.addressDoor))
      ) {
        return true
      } else {
        dispatch(setDualAddressAlert(true))
        checkDualDirection = true
        put(`orders/${orderId}/dual_address_message`, { dualAddressMessage: 'warning' })
        return true
      }
    }
    return true
  }

  const handleFormSubmit = async (formData) => {
    const city = cities?.find((city) => city.id === formData.city)
    const townName = city?.name || formData.municipalityName
    const municipalityName = city?.name || formData.municipalityName
    const province = cpProvinces[formData.province] || formData.province
    const numeroRegex = /^-?\d*([.,]?\d+)?$/

    const streetName =
      streetSuggestions?.find((street) => street.externalId === formData.street)?.name?.toUpperCase() || formData.street

    const externalId = streetSuggestions?.find(
      (street) => street.name === formData.street || street.name === streetName
    )?.externalId

    const { postalCode, streetType, number, portal, stair, floor, door, extraData } = formData
    const isValidObject = (obj) =>
      obj && typeof obj === 'object' && Object.values(obj).some((value) => value !== undefined && value !== null && value !== '')
    let address
    if (!isMultiPoint) {
      if (addressCups && isValidObject(addressCups)) {
        address = {
          tenureAddressId: '',
          addressLine: addressCups?.addressLine,
          externalId: addressCups?.externalId,
          postalCode: addressCups?.postalCode,
          provinceName: addressCups?.provinceName,
          municipalityName: addressCups?.municipalityName,
          townName: addressCups?.municipalityName,
          streetType: addressCups?.streetType,
          streetName: addressCups?.streetName,
          number: addressCups?.number,
          portal: addressCups?.portal,
          stair: addressCups?.stair,
          floor: addressCups?.floor,
          door: addressCups?.door,
          cups: addressCups?.cupsID || addressCups?.gasCupsID || addressCups,
          electricityCups: energyStep.toLowerCase() === ELECTRICITY ? addressCups?.cupsID || addressCups : '',
          gasCups: energyStep.toLowerCase() === GAS ? addressCups?.gasCupsID || addressCups : '',
          provinceCode: provinceCode,
          municipalityCode: municipalityCode,
          extraData: extraData,
        }
      } else {
        address = {
          tenureAddressId: '',
          addressLine: mapNewSupplyAddressLine({ ...formData, streetName }),
          externalId: externalId,
          postalCode: postalCode,
          provinceName: province || formData.province,
          municipalityName: municipalityName,
          townName: townName,
          streetType: streetType,
          streetName: streetName,
          number: number,
          portal: portal,
          stair: stair,
          floor: floor,
          door: door,
          extraData: extraData,
          cups: addressCups?.gasCupsID || addressCups,
          electricityCups: energyStep.toLowerCase() === ELECTRICITY ? addressCups?.cupsID || addressCups : '',
          gasCups: energyStep.toLowerCase() === GAS ? addressCups?.gasCupsID || addressCups : '',
          provinceCode: provinceCode,
          municipalityCode: municipalityCode,
        }
      }
    } else {
      address = {
        tenureAddressId: '',
        addressLine: mapNewSupplyAddressLine({ ...formData, streetName }) || '',
        externalId: externalId || '',
        postalCode: postalCode || '',
        provinceName: province || '',
        municipalityName: municipalityName || '',
        townName: municipalityName || townName || '',
        streetType: streetType || '',
        streetName: streetName || '',
        number: number || '',
        portal: portal || '',
        stair: stair || '',
        floor: floor || '',
        door: door || '',
        extraData: extraData || '',
        provinceCode: provinceCode,
        municipalityCode: municipalityCode,
      }
    }

    let secondAddress = {}
    let checkAddress = false
    let tenureCheck = false
    if (isElectricitySelected || isGasSelected || isGasInDual) {
      checkAddress = true

      if (selectedTenure && isNotEmpty(selectedTenure)) {
        tenureCheck = true
        secondAddress = {
          number: selectedTenure?.addressNumber,
          floor: selectedTenure?.addressFloor,
          door: selectedTenure?.addressDoor,
          streetName: selectedTenure?.addressStreet,
          postalCode: selectedTenure?.postalCode,
        }
      } else {
        if (!isDual) {
          checkAddress = false
        }
        secondAddress = {
          number: supplyAddress?.number,
          floor: supplyAddress?.floor,
          door: supplyAddress?.door,
          streetName: supplyAddress?.streetName,
          postalCode: supplyAddress?.postalCode,
        }
      }
    } else {
      checkAddress = true
      secondAddress = {
        number: supplyAddress?.number,
        floor: supplyAddress?.floor,
        door: supplyAddress?.door,
        streetName: supplyAddress?.streetName,
        postalCode: supplyAddress?.postalCode,
      }
    }
    const tenureElectricity =
      selectedTenure && selectedTenure.products && selectedTenure.products.find((product) => product.type === 'ELECTRICITY')
    const tenureGas =
      selectedTenure && selectedTenure.products && selectedTenure.products.find((product) => product.type === 'GAS')
    const fidelization = (tenureElectricity && service === ELECTRICITY) || (tenureGas && service === GAS)

    const addresToCompare = [address, secondAddress]
    if (checkDualAddress(addresToCompare, step, checkAddress, tenureCheck)) {
      let technicalInfo = { energyType: energyStep.toUpperCase(), cups: addressCups }
      let calculatorInfo
      let technicalInfoFromCUPS = false
      let addressId = null
      let niceAddress = mapNewSupplyAddressLine({ ...formData, streetName,postalCode,province })
      
      try {
        setIsLoading(true)
        
        // 🆕 NUEVO FLUJO SIMPLIFICADO:
        // 1. Guardar dirección en Redux (sin ID)
        // 2. Disparar action que construye lead completo desde Redux
        // 3. El saga construirá el lead con mapLeadData y getOrders
        if (leadId) {
          const supplyAddressPayload = {
            postalCode,
            provinceName: province,
            provinceCode,
            municipalityName,
            municipalityCode,
            townName,
            streetType,
            streetName,
            number,
            portal: portal || '',
            stair: stair || '',
            floor: floor || '',
            door: door || '',
            extraData: extraData || '',
            externalId: externalId || '',
            electricityCups: energyStep.toLowerCase() === ELECTRICITY ? (checkAddressObject?.cups || '') : '',
            gasCups: energyStep.toLowerCase() === GAS ? (checkAddressObject?.cups || '') : '',
            isNewAddress: true,
          }
          
          // Guardar dirección en Redux PRIMERO (sin ID)
          dispatch(setSupplyAddress(supplyAddressPayload))
          dispatch(setSupplyAddressPayload(supplyAddressPayload))
          
          // Disparar fetchLead() que activará el saga
          // El saga construirá el lead completo usando mapLeadData y getOrders
          // y lo enviará al backend
          dispatch(fetchLead())
          
          // Activar flag para esperar el addressId y guardar datos pendientes
          setWaitingForAddressId(true)
          setPendingFormData({
            formData: { ...formData, checkDualDirection },
            niceAddress,
            numeroRegex
          })
          
          // El useEffect se encargará de continuar el flujo cuando Redux se actualice
          return
        }
        
        if (supplyTechnicalInfo) {
          if (
            supplyTechnicalInfo &&
            supplyTechnicalInfo.accessTariff &&
            supplyTechnicalInfo.consumption12Months &&
            (!numeroRegex.test(supplyTechnicalInfo.consumption12Months) ||
              isNaN(parseFloat(supplyTechnicalInfo.consumption12Months)) ||
              parseFloat(technicalInfoFromCUPS.consumption12Months) <= 0)
          ) {
            const tariffData = await getTariffData(service, selectedProduct, channel)
            supplyTechnicalInfo.consumption12Months = tariffData.find(
              (tariff) => tariff.type === supplyTechnicalInfo.accessTariff
            ).defaultAnnualConsumption
          }
          technicalInfo = { ...supplyTechnicalInfo, ...technicalInfo }
        } else if (addressId && leadId) {
          // 🆕 Usar el nuevo servicio getTechnicalInfo con addressId
          const techInfoResponse = await getTechnicalInfo({
            leadId,
            addressId,
            energyType: energyStep.toUpperCase(),
            productId: selectedProduct.find((elem) => elem.energyType === energyStep.toUpperCase())?.id
          })
          
          if (techInfoResponse.success && techInfoResponse.data) {
            technicalInfoFromCUPS = techInfoResponse.data
            
            if (
              technicalInfoFromCUPS &&
              technicalInfoFromCUPS.accessTariff &&
              technicalInfoFromCUPS.consumption?.consumption12Months &&
              (!numeroRegex.test(technicalInfoFromCUPS.consumption.consumption12Months) ||
                isNaN(parseFloat(technicalInfoFromCUPS.consumption.consumption12Months)) ||
                parseFloat(technicalInfoFromCUPS.consumption.consumption12Months) <= 0)
            ) {
              const tariffData = await getTariffData(service, selectedProduct, channel)
              technicalInfoFromCUPS.consumption.consumption12Months = tariffData.find(
                (tariff) => tariff.type === technicalInfoFromCUPS.accessTariff
              ).defaultAnnualConsumption
            }

            // Spread de los datos técnicos (nuevo formato anidado)
            technicalInfo = {
              ...technicalInfo,
              ...technicalInfoFromCUPS.consumption,
              ...technicalInfoFromCUPS.capacity,
              accessTariff: technicalInfoFromCUPS.accessTariff,
              contractType: technicalInfoFromCUPS.contractType,
              cnae: technicalInfoFromCUPS.cnae,
              codResult: technicalInfoFromCUPS.codResult,
              descResult: technicalInfoFromCUPS.descResult,
            }
          }
        }
        if (shouldGetCalculations) {
          calculatorInfo = await getCalculatorInfo(addressCups, technicalInfo?.energyType, companyCode)
        }
      } catch (error) {
        // Only show flat rate error modal if the product is actually a flat rate
        const isFlatRateProduct = selectedProduct?.some(
          (product) => product.energyType?.toUpperCase() === technicalInfo?.energyType?.toUpperCase() && product.flatRate
        )
        if (step === 3 && isFlatRateProduct) {
          handleClose()
          dispatch(
            showModal({
              modalType: MODAL_TYPES.errorFlateRate,
              modalData: {
                translationLabel: 'technicalFlatRate',
                energyType: technicalInfo?.energyType || service, // Add energyType here
              },
            })
          )
          return
        }
      } finally {
        setIsLoading(false)
      }
      const validationClientNode = technicalInfo?.validationClientNode
      let validationClienNodeModal = false
      if (!validationClientNode && validationClientNode !== null && !fidelization && validationClientNode !== undefined) {
        validationClienNodeModal = true
      }
      
      // Construir finalAddress con addressId si está disponible
      // IMPORTANTE: Incluir también los campos del formulario (formData) para que provinceName y otros campos se envíen al backend
      const addressData = addressId ? { 
        id: addressId, 
        niceAddress,
        ...formData // Incluir todos los campos del formulario (provinceName, municipalityName, etc.)
      } : (isGasInDual ? supplyAddress : address)
      const finalAddress = { data: addressData || false, type: ADDRESS }

      // TODO: Move it to redux sagas, also in cointainers/SupplyStep
      const isContratable = checkIsContratable(technicalInfo?.contratable)

      if (isContratable) {
        completeSupplyPoint(
          technicalInfo,
          finalAddress,
          calculatorInfo,
          handleClose,
          checkDualAddresAlert || checkDualDirection,
          validationClienNodeModal
        )
      }
    }
  }

  const validateForm = (values) => {
    const errors = {}
    const requiredFields = ['postalCode', 'city', 'province', 'streetType', 'street', 'number']

    requiredFields.forEach((field) => {
      if (values[field] === '' || values[field] === false) {
        errors[field] = t('form.errors.required')
      }
    })

    if (values.number && !validateNumber(values.number)) {
      errors.number = t('form.errors.numberFormat')
    }

    if (values.portal && !validatePortal(values.portal)) {
      errors.portal = t('form.errors.portalFormat')
    }

    if (values.stair && !validateStair(values.stair)) {
      errors.stair = t('form.errors.stairFormat')
    }

    if (values.floor && !validateFloor(values.floor)) {
      errors.floor = t('form.errors.floorFormat')
    }

    if (values.door && !validateDoor(values.door)) {
      errors.door = t('form.errors.doorFormat')
    }

    //check if error has content
    Object.keys(errors).length > 0 ? setBtnState(true) : setBtnState(false)
    return errors
  }

  const handlePostalCodeChange = async (e, setFieldValue, address, setAddresFromService) => {
    if (e.target.value && validatePostalCode(e.target.value)) {
      const normalizedAddres = address?.roadType ? mapEmergyaAddress(address) : address
      let addresAux = normalizedAddres
      const provinceCode = e.target.value.substring(0, 2)
      const postalCode = e.target.value
      setFieldValue('province', provinceCode, false)
      const cities = await getNormalizedCities(postalCode)
      const { id, name } = cities.length ? cities[0] : ''
      const provinceId = id?.slice(0, 2)
      const municipalityId = id?.slice(2, 5)
      setFieldValue('city', name)
      if (addresAux && (!addresAux.hasOwnProperty('municipalityName') || !addresAux?.municipalityName)) {
        addresAux.municipalityName = name
      }
      setMunicipalityCode(municipalityId)
      setProvinceCode(provinceId)
      setCities(cities)
      const streets = await getNormalizedStreets(postalCode)
      setAllStreets(streets)
      if (streets && streets.length) {
        const uniqStreetTypes = [...new Set(streets.map((item) => capitalizeFirstLetter(item.type)))].sort()
        setStreetTypes(uniqStreetTypes)
      }

      if (normalizedAddres && cities && cities.length > 0 && streets && streets.length > 0) {
        if (streets && streets.length > 0) {
          const type = (normalizedAddres.streetType || normalizedAddres.roadTypeName || '').toUpperCase()

          const filteredStreetSugestions = type ? streets?.filter((street) => street.type === type.toUpperCase()) : []
          setStreetSuggestions(filteredStreetSugestions)
          setAddresFromService(addresAux, cities, filteredStreetSugestions)
        } else {
          setAddresFromService(addresAux, cities)
        }
      }
    } else if (cities.length) {
      setCities([])
      setStreetTypes([])
      setAllStreets([])
      setFieldValue('city', '', false)
      setFieldValue('streetType', '', false)
      setFieldValue('street', '', false)
    }
  }

  const handleStreetTypeChange = (streetType) => {
    const filteredStreetSugestions = streetType ? allStreets?.filter((street) => street.type === streetType.toUpperCase()) : []
    setStreetSuggestions(filteredStreetSugestions)
  }

  // useEffect para continuar el flujo cuando Redux se actualice con el addressId
  useEffect(() => {
    const continueTechnicalInfoFlow = async () => {

      if (waitingForAddressId && supplyAddress?.id && pendingFormData) {
        
        // 🆕 NO obtener datos técnicos si es dirección de billing
        const isBilling = step === 'billing' || step === 5 || step === STEPS.billing
        
        if (isBilling) {
          setIsLoading(false)
          setWaitingForAddressId(false)
          
          // Para billing, construir niceAddress desde pendingFormData
          const { formData, niceAddress: pendingNiceAddress } = pendingFormData
          
          // Construir niceAddress desde los datos del formulario si no existe
          const finalNiceAddress = supplyAddress.niceAddress || pendingNiceAddress || mapNewSupplyAddressLine(formData)
          
          // 🆕 Extraer solo el ID sin la ruta /middleware/addresses/
          const addressIdOnly = supplyAddress.id?.replace(/^\/middleware\/addresses\//, '') || supplyAddress.id
          
          setPendingFormData(null)
          
          // Para billing, solo cerrar la modal y completar
          if (completeSupplyPoint) {
            const addressData = { 
              id: addressIdOnly, 
              niceAddress: finalNiceAddress,
              ...formData // Incluir todos los campos del formulario
            }
            completeSupplyPoint(
              null, // No hay technical info en billing
              { data: addressData, type: ADDRESS },
              null, // No hay calculator info
              handleClose
            )
          } else {
            handleClose()
          }
          return
        }
        
        const {  niceAddress } = pendingFormData
        
        try {
          setIsLoading(true)
          setWaitingForAddressId(false)
          
          // Llamar a getTechnicalInfo con el addressId de Redux
          const techInfoResponse = await getTechnicalInfo({
            leadId,
            addressId: supplyAddress.id,
            energyType: energyStep.toUpperCase(),
            productId: selectedProduct?.id ?? selectedProduct.find((elem) => elem.energyType === energyStep.toUpperCase())?.id
          })

          
          
          // 🆕 NUEVO: Si errorCode es '08', significa que hay datos técnicos incompletos
          // En lugar de llamar a wrongCupsValidation, continuar y abrir NewSupplyTechnical
          if (!techInfoResponse.success && techInfoResponse?.errorCode && techInfoResponse?.errorCode !== '01') {
            if (techInfoResponse?.errorCode === '08') {
              // ErrorCode 04: Datos técnicos incompletos - continuar con el flujo normal
              // para abrir NewSupplyTechnical y permitir completar los datos
            } else {
              // Para otros errores, llamar a wrongCupsValidation
              wrongCupsValidation(techInfoResponse?.errorCode)
              setIsLoading(false)
              handleClose()
              return
            }
          }
          
          // Continuar con la apertura de la modal
          setIsLoading(false)
            
            // Cerrar la modal actual ANTES de abrir la siguiente
            handleClose()
            
            // Pequeño delay para asegurar que la modal actual se cierra antes de abrir la siguiente
            setTimeout(async () => {
              setPendingFormData(null)
              // Abrir modal NewSupplyTechnical para introducir datos manualmente
              const addressData = { id: supplyAddress.id, niceAddress: supplyAddress.niceAddress || niceAddress }
              const finalAddress = { data: addressData, cups: addressCups, type: ADDRESS }
            
              // Obtener tariffData para la modal
              const tariffData = await getTariffData(energyStep, selectedProduct, channel)
              
              // Crear función onSubmit personalizada que guarde en Redux y luego envíe al backend
              const customOnSubmit = async (technicalInfo, address, calculatorInfo, closeModal, checkDualAddresAlert, validationClienNodeModal) => {
              
                try {
                  // Activar loading ANTES de cualquier operación
                  setIsSendingLead(true)
                // 🆕 IMPORTANTE: Asegurar que contractType esté definido
                const technicalInfoWithContractType = {
                  ...technicalInfo,
                  contractType: technicalInfo.contractType
                }
                                
                // 🆕 NUEVO ENFOQUE: Guardar directamente en Redux usando setSupplyPoint
                // IMPORTANTE: El backend espera technicalInfoElectricity o technicalInfoGas
                const energyType = technicalInfoWithContractType.energyType
                const technicalInfoKey = energyType === 'ELECTRICITY' ? 'technicalInfoElectricity' : 'technicalInfoGas'
                
                // Construir el objeto supplyPoint con el formato correcto
                const supplyPointData = [{
                  supplyAddress: address?.data || address,
                  [technicalInfoKey]: {
                    ...technicalInfoWithContractType,
                    ...calculatorInfo,
                  }
                }]
                       
                // PASO 1: Guardar datos técnicos en Redux usando setSupplyPoint
                // Esto actualiza tanto customer.supplyPoint como customer.supplyPoints
                
                // Verificar si el CUPS ya existe en supplyPoints
                const cupsToCheck = technicalInfoWithContractType.cups
                
                // Si supplyPoints es null o solo hay un producto seleccionado, usar setSupplyPoint
                const emptyIndex = supplyPoints ? supplyPoints?.findIndex((supplyPoint) => supplyPoint?.cups === null) : null
                if(emptyIndex !== -1 && emptyIndex !== null){
                  // Si hay un emptyIndex, reemplazar en esa posición
                  const newSupplyPoints = [...supplyPoints]
                  newSupplyPoints[emptyIndex] = supplyPointData[0]
                  dispatch(setSupplyPoint(newSupplyPoints))
                } else if (!supplyPoints || selectedProduct?.length === 1) {
                  dispatch(setSupplyPoint(supplyPointData))
                } else if (isDual) {
                  // En caso de isDual, añadir al existente en lugar de sobreescribir
                  dispatch(setSupplyPoint([...supplyPoints, ...supplyPointData]))
                } else{
                  dispatch(setSupplyPoint(supplyPointData))
                }
                
                // PASO 2: Verificar si hay productos seleccionados
                const hasSelectedProducts = selectedProduct            
                // PASO 3: Si hay productos, enviar el lead DIRECTAMENTE
                if (hasSelectedProducts) {
                  // Usar setTimeout para asegurar que Redux se actualice primero
                  setTimeout(() => {
                    dispatch(fetchLead())
                  }, 200)
                } else {
                  // Si no hay productos, desactivar loading
                  setIsSendingLead(false)
                }
                
                // PASO 4: Completar el paso de suministro para permitir avanzar al paso 3
                // Llamar a completeSupplyPoint con los datos para que marque el paso como completado
                if (completeSupplyPoint) {
                  completeSupplyPoint(
                    technicalInfoWithContractType,
                    { data: address?.data || address, type: ADDRESS },
                    calculatorInfo,
                    closeModal,
                    checkDualAddresAlert,
                    validationClienNodeModal
                  )
                } else if (closeModal) {
                  // Si no hay completeSupplyPoint, solo cerrar modal
                  closeModal()
                }
                
                // PASO 5: Actualizar isContractCapacityVisible si la función está disponible
                } catch (error) {
                  setIsSendingLead(false)
                }
              }
              
              dispatch(
                showModal({
                  modalType: MODAL_TYPES.newSupplyTechnical,
                  modalData: {
                    onSubmit: customOnSubmit,
                    service: energyStep,
                    address: finalAddress,
                    tariffData,
                    technicalInfo: {},
                    isNewSupplySwitchDisabled: false,
                    openCupsModal: techInfoResponse?.data?.contractType !== 'CCT' || techInfoResponse?.data?.contractType !== 'CC' ,
                    isNewSupplyChecked: true,
                    onNewSupplyChange: onNewSupplyChange || (() => {}), // ✅ Pasar la función o fallback vacío
                    verticalsDetail, // ✅ Pasar verticalsDetail para que NewSupplyTechnical pueda pre-rellenar campos
                  },
                })
              )
            }, 100) // Delay de 100ms para asegurar que la modal anterior se cierra
        } catch (error) {
          console.log('error', error)
          setIsLoading(false)
          setPendingFormData(null)
          
          const isFlatRateProduct = selectedProduct?.some(
            (product) => product.energyType?.toUpperCase() === energyStep.toUpperCase() && product.flatRate
          )
          if (step === 3 && isFlatRateProduct) {
            handleClose()
            dispatch(
              showModal({
                modalType: MODAL_TYPES.errorFlateRate,
                modalData: {
                  translationLabel: 'technicalFlatRate',
                  energyType: energyStep || service,
                },
              })
            )
          }
        }
      }
    }
    
    continueTechnicalInfoFlow()
  }, [
    waitingForAddressId,
    supplyAddress?.id,
    supplyAddress?.niceAddress,
    pendingFormData,
    energyStep,
    addressCups,
    leadId,
    verticalsDetail,
    selectedProduct,
    channel,
    service,
    shouldGetCalculations,
    companyCode,
    checkIsContratable,
    completeSupplyPoint,
    handleClose,
    checkDualAddresAlert,
    step,
    dispatch,
    setIsContractCapacityVisible,
    supplyModeService,
    isOnlineChannel,
    isOnlyToppings,
    isDual,
    onNewSupplyChange,
    wrongCupsValidation,
    supplyPoints,
  ])

  // useEffect para enviar lead cuando supplyPoints se actualice con datos técnicos
  useEffect(() => {
    if (shouldSendLead && supplyPoints && supplyPoints.length > 0) {
      const hasTechnicalInfo = supplyPoints.some(
        (sp) => sp.technicalInfoElectricity || sp.technicalInfoGas
      )
      
      if (hasTechnicalInfo) {
        dispatch(fetchLead())
        setShouldSendLead(false) // Reset flag
      }
    }
  }, [supplyPoints, shouldSendLead, dispatch])

  useEffect(() => {
    const address = checkAddressObject?.mappedAddress || {}
    
    // Verificar si hay placeIDGoogle en checkAddressObject o en verticalsDetail
    const hasPlaceIdFromCheckAddress = address.placeIDGoogle &&
      (
        (address.externalId && address.externalId !== 'undefined' && address.externalId !== '0' && address?.number) ||
        // También mostrar si viene de AddressSearch sin número (usuario seleccionó "No encuentro mi piso")
        (address.description && !address.number)
      )
    
    const hasPlaceIdFromVerticals = verticalsDetail?.placeIDGoogle
    
    if (hasPlaceIdFromCheckAddress || hasPlaceIdFromVerticals) {
      setGoogleAddress(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verticalsDetail])

  // useEffect para desactivar loading cuando el lead se complete
  useEffect(() => {
    if (isSendingLead && lead) {
      setIsSendingLead(false)
    }
  }, [lead, isSendingLead])

  return (
    <NewSupplyView>
      <Formik initialValues={initialValues} validate={validateForm} onSubmit={handleFormSubmit} enableReinitialize>
        {({ handleChange, values, errors, touched, setFieldValue }) => (
          <Form noValidate autoComplete="off">
            <Box my={3}>
              <Typography variant="basic">
                {service === ELECTRICITY ? t('newSupplyPoint.electricityDescription') : t('newSupplyPoint.gasDescription')}
              </Typography>
            </Box>

            {/* {showNewSupplyAddress && !isMultiPoint && (
              <Box mt={5}>
                <Box mb={1.5}>
                  <Typography variant="h5" color="primary">
                    {t('addressType', { type: t(`common.${service.toLowerCase()}`) })}
                  </Typography>
                </Box>
                <CardContent data={{ ...supplyAddress, addressCups }} showCardContent showNewSupplyAddress />
              </Box>
            )} */}

            {showAddress && (
              <>
                <Box mt={4} mb={2}>
                  <Typography variant="h5" color="primary">
                    {t('newSupplyPoint.addressTitle')}
                  </Typography>
                </Box>
                <AddressForm
                  onChange={handleChange}
                  onPostalCodeChange={handlePostalCodeChange}
                  onStreetTypeChange={handleStreetTypeChange}
                  cities={cities}
                  cityInputValue={cityInputValue}
                  setFieldValue={setFieldValue}
                  setCityInputValue={setCityInputValue}
                  streetSuggestions={streetSuggestions}
                  streetTypes={streetTypes}
                  values={values}
                  errors={errors}
                  touched={touched}
                  notFoundAddress={notFoundAddress}
                />

                {values.streetType && (
                  <Box mt={3}>
                    <Typography color="textPrimary" variant="basic">
                      <Trans i18nKey="form.fields.notFoundAddress">
                        <Link variant="link" to="" onClick={(e) => handleNotFoundAddress(e, setFieldValue)} />
                      </Trans>
                    </Typography>
                  </Box>
                )}

                {!isEmptyObject(errors) && !isEmptyObject(touched) && <AddressErrorsAlert errors={errors} touched={touched} />}
              </>
            )}

            {/* {service.includes(ELECTRICITY) && (
              <ElectricityNewSupply
                values={values}
                onChange={handleChange}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                tariffs={tariffs}
                getVariantInfo={getVariantInfo}
                onTariffChange={handleTariffChange}
                onMaxPowerChange={handleMaxPowerChange}
                plannedDischargeDate={plannedDischargeDate}
                onPlannedDischargeDateChange={handlePlannedDischargeDateChange}
                newSupply={newSupply}
                referenceSegment={referenceSegment}
                valueDefaultAnnualConsumption={valueDefaultAnnualConsumption}
              />
            )}

            {service.includes(GAS) && (
              <GasNewSupply
                values={values}
                onChange={handleChange}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                tariffs={tariffs}
                getVariantInfo={getVariantInfo}
                plannedDischargeDate={plannedDischargeDate}
                onPlannedDischargeDateChange={handlePlannedDischargeDateChange}
                newSupply={isNewSupplyGasChecked}
                referenceSegment={referenceSegment}
                valueDefaultAnnualConsumption={valueDefaultAnnualConsumption}
              />
            )} */}

            {/* {!isValidCapacities && (
              <Box mt={4}>
                <Alert severity="warning">
                  <Typography variant="basic">{t('rateSelectedMinCapacity', { value: 15 })}</Typography>
                </Alert>
              </Box>
            )} */}

            <Box display="flex" justifyContent="flex-start" alignItems="center" mt={5} mb={3}>
              <Button type="submit" variant="contained" color="secondary">
                {t('common.continue')}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </NewSupplyView>
  )
}

export default NewSupplyAddress
